import * as types from '../mutation-types'
import { API } from '../../api'
import { SEARCH_DATA_MANAGER } from '../../data'

export default {
    namespaced: true,
    state: {
        advancedType: '',
        searchFromPage: "",
        searchSelectedData: {situation: 0, sex: -1, age: 0}, //默认筛选条件
        showChooseItemPop: false,
        searchChooseItemList: [],
        searchChoosedBoxPos: [],
        searchChooseBoxList: [
            [{type: 'tg_1', pos: [0, 0], choosedData: {}}, {type: 'dz_1', pos: [0, 1], choosedData: {}}],
            [{type: 'tg_2', pos: [1, 0], choosedData: {}}, {type: 'dz_2', pos: [1, 1], choosedData: {}}],
            [{type: 'tg_3', pos: [2, 0], choosedData: {}}, {type: 'dz_3', pos: [2, 1], choosedData: {}}],
            [{type: 'tg_4', pos: [3, 0], choosedData: {}}, {type: 'dz_4', pos: [3, 1], choosedData: {}}],
        ],
        searchData: { searchText: ''},
        searchResultFromPage: '',
        searchResultList: [],
        searchAdvancedResultList: [],
        searchResultSelectedList: [],
        showSearchItemSelect: false
    },
    getters: {},
    mutations: {
        [types.SEARCH_UPDATE_CHOOSE_ITEM_POP_DATA](state, data) {
            var type = data.type.slice(0, 2);
            var x = data.pos[0], y = data.pos[1], yy = y == 0 ? 1 : 0;
            var choosedData = state.searchChooseBoxList[x][y]['choosedData'];
            var compData = state.searchChooseBoxList[x][yy]['choosedData'];
            console.log('types.SEARCH_UPDATE_CHOOSE_ITEM_POP_DATA----', type, compData, choosedData)
            // 暂存当前被点击数据的位置
            state.searchChoosedBoxPos = data.pos;
    
            if(state.advancedType == 'ganzhi'){
                switch(type){
                    case 'tg':
                        state.searchChooseItemList = SEARCH_DATA_MANAGER.getTianGanListByCompData(compData);
                        break;
                    case 'dz':
                        state.searchChooseItemList = SEARCH_DATA_MANAGER.getDiZhiListByCompData(compData);
                        break;
                    default:
                        break;
                }
            }else if(state.advancedType == 'wuxing'){
                state.searchChooseItemList = SEARCH_DATA_MANAGER.getWuXingList();
            }
            
        },
        [types.SEARCH_CHOOSE_CHOOSE_ITEM_DATA](state, data) {
            var boxPos = state.searchChoosedBoxPos;
            // 处理UI数据
            state.searchChooseBoxList[boxPos[0]][boxPos[1]]['choosedData'] = Object.assign({}, data);
            console.log('types.SEARCH_CHOOSE_CHOOSE_ITEM_DATA----', state.searchChooseBoxList);
            // 处理搜索过滤数据:这样处理以强制刷新虚拟列表
            state.searchAdvancedResultList.splice(0);
            var recordTotalData = AppFate.$store.state.record.recordTotalData;
            setTimeout(() => {
                state.searchAdvancedResultList = SEARCH_DATA_MANAGER.getSearchResultListByChooseBoxList(recordTotalData, state.searchChooseBoxList);
            }, 10);
        },
        [types.SEARCH_CONFIRM_INPUT_SEARCH](state, word) {
            var searchSelectedData = state.searchSelectedData;
            var recordTotalData = AppFate.$store.state.record.recordTotalData;
            state.searchResultList = SEARCH_DATA_MANAGER.getSearchResultListByWord(recordTotalData, word, searchSelectedData);
            console.log("types.SEARCH_CONFIRM_INPUT_SEARCH", word, searchSelectedData, state.searchResultList);
        },
        [types.SEARCH_RESET_DATA](state) {
            state.searchSelectedData = Object.assign({situation: 0, sex: -1, age: 0});
            state.searchResultList = [];
            state.searchData = { searchText: '' };
            state.searchAdvancedResultList = [];
            state.searchResultSelectedList = [];
            state.showSearchItemSelect = false;
            
            for(var i = 0; i < 4; i++){
                state.searchChooseBoxList[i][0]['choosedData'] = Object.assign({});
                state.searchChooseBoxList[i][1]['choosedData'] = Object.assign({});
            }
        },
        [types.SEARCH_DELETE_RESULT_LIST_DATA](state, deleteId) {
            if(state.searchResultList.length > 0){
                state.searchResultList = SEARCH_DATA_MANAGER.deleteSearchResultListByDataId(state.searchResultList, deleteId);
            }
            if(state.searchAdvancedResultList.length > 0){
                state.searchAdvancedResultList = SEARCH_DATA_MANAGER.deleteSearchResultListByDataId(state.searchAdvancedResultList, deleteId);
            }
        }
    },
    actions: {
        updateSearchChooseData({ commit }, data){
            commit(types.SEARCH_UPDATE_CHOOSE_ITEM_POP_DATA, data);   
        },
        chooseSearchChooseData({ commit }, data){
            commit(types.SEARCH_CHOOSE_CHOOSE_ITEM_DATA, data);
        },
        confirmSearchInput({ commit }, word){
            commit(types.SEARCH_CONFIRM_INPUT_SEARCH, word);
        },
        confirmSearchLabel({ state }, params) {
            var recordTotalData = AppFate.$store.state.record.recordTotalData;
            state.searchResultList = SEARCH_DATA_MANAGER.getSearchResultListByLabel(recordTotalData, params.labelId);
            if(params.cb && typeof(params.cb) == 'function') {
                params.cb(state.searchResultList);
            }
        },
        deleteSearchResultList({ commit }, deleteId){
            commit(types.SEARCH_DELETE_RESULT_LIST_DATA, deleteId);
        },
        updateSearchListChoosedItemStatus({state}, params) {
            let sLastData = state.searchResultList.find(el => params.lastData ? el.id == params.lastData.id : null);
            let sCurData = state.searchResultList.find(el => params.curData ? el.id == params.curData.id : null);
            if(sLastData) { sLastData.selected = false; }
            if(sCurData) { sCurData.selected = true; }
        },
        addSearchResultSelectedList({state}, params) {
            if(params.type == 'all') {
                state.searchResultSelectedList = [].concat(params.idArr);
            }else if(params.type == 'add') {
                state.searchResultSelectedList = state.searchResultSelectedList.concat(params.idArr);
            }
        },
        removeSearchResultSelectedList({state}, params) {
            state.searchResultSelectedList = state.searchResultSelectedList.filter(el => params.idArr.indexOf(el) == -1);
        },
        resetSearchListChoosedItemStatus({state}) {
            state.searchResultList.forEach(el => el.selected = false);
        },
        resetData({ dispatch, commit }){
            commit(types.SEARCH_RESET_DATA);
            dispatch('record/resetRecordListChoosedItemStatus', {}, {root: true});
            dispatch('search/resetSearchListChoosedItemStatus', {}, {root: true});
        }
    }
}